import { render } from "./Society.vue?vue&type=template&id=6b452266"
import script from "./Society.vue?vue&type=script&lang=js"
export * from "./Society.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__